var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F90"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.957 24.677c.16-1.05-.12-1.96-.83-2.711-.32-.36-.73-.62-1.12-.95.07-.02.12-.05.16-.06 2.53-.48 3.311-3.922 2.05-5.543a5.89 5.89 0 0 0-1.86-1.55c-.51-.27-1.02-.52-1.56-.78.28-.971.7-2.332 1.01-3.412l-2.041-.59c-.33 1.06-.71 2.39-1.01 3.33l-1.641-.48c.29-.97.69-2.27.99-3.33L20.055 8c-.31 1.08-.721 2.421-1.071 3.331-1.4-.43-2.761-.82-4.142-1.24-.22.75-.44 1.45-.65 2.18.29.11.55.18.82.26.26.08.52.151.78.251.69.26.95.76.75 1.47-.87 2.932-1.76 5.853-2.65 8.774-.18.64-.52.82-1.16.64l-.02-.01-1.361-.4c-.39.8-.75 1.541-1.14 2.321 1.4.43 2.73.83 4.13 1.26-.31 1.061-.71 2.392-1.03 3.492l2.051.6c.34-1.1.72-2.4 1.04-3.43.58.17 1.101.34 1.631.51-.3 1.05-.7 2.33-1.01 3.39l2.05.601c.34-1.1.711-2.391 1.021-3.391.07.02.12.01.17.03 1.04.12 2.051.33 3.072.37 1.34.06 2.52-.36 3.401-1.44.68-.831 1.07-1.822 1.22-2.892Zm-7.503-10.304 1.05.3c.901.26 1.781.58 2.512 1.19.67.56.86 1.28.6 2.041-.27.79-.91 1.24-1.8 1.26-.881.05-1.721-.14-2.562-.38-.35-.1-.69-.22-1.02-.32.4-1.35.79-2.69 1.22-4.091Zm1.461 11.494c-1.27.18-2.481-.17-3.682-.5l-.07-.02c-.32-.09-.63-.2-.97-.3.46-1.51.91-3.001 1.37-4.502l1.211.35c1.16.34 2.261.72 3.171 1.491.65.53.93 1.24.69 2.1-.25.851-.87 1.261-1.72 1.381Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.a7407f7f.svg";
export { ForwardRef as ReactComponent };